/* Flannel Daddy release-QA fixes — v2.2.11. Keep isolated from core theme.js for easy rollback. */
(function(){
  if (typeof updateVariant === 'function') {
    var fdOriginalUpdateVariant = updateVariant;
    updateVariant = function(root) {
      var originalReplaceState = history.replaceState;
      history.replaceState = function(state, title, url) {
        try {
          var current = new URL(location.href);
          var next = new URL(url, location.href);
          current.searchParams.forEach(function(value, key) {
            if (key !== 'variant' && !next.searchParams.has(key)) next.searchParams.append(key, value);
          });
          if (!next.hash && current.hash) next.hash = current.hash;
          return originalReplaceState.call(history, state, title, next.pathname + next.search + next.hash);
        } catch (err) {
          return originalReplaceState.call(history, state, title, url);
        }
      };
      try { return fdOriginalUpdateVariant(root); }
      finally { history.replaceState = originalReplaceState; }
    };
  }

  function initFilterA11y(){
    document.querySelectorAll('[data-facet-root]').forEach(function(root, index){
      var panel = root.querySelector('[data-filter-panel]');
      var toggle = root.querySelector('[data-filter-toggle]');
      var close = root.querySelector('[data-filter-close]');
      if (!panel || !toggle) return;
      if (!panel.id) panel.id = 'FacetPanel-' + (root.getAttribute('data-section-id') || index + 1);
      toggle.setAttribute('aria-controls', panel.id);
      toggle.setAttribute('aria-expanded', panel.classList.contains('is-open') ? 'true' : 'false');
      if (!toggle.getAttribute('aria-label')) toggle.setAttribute('aria-label','Open filters');
      if (close && !close.getAttribute('aria-label')) close.setAttribute('aria-label','Close filters');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFilterA11y);
  else initFilterA11y();

  document.addEventListener('click', function(e) {
    var toggle = e.target.closest && e.target.closest('[data-filter-toggle]');
    if (toggle) {
      setTimeout(function(){
        var root = toggle.closest('[data-facet-root]') || document;
        var panel = root.querySelector('[data-filter-panel]');
        toggle.setAttribute('aria-expanded', panel && panel.classList.contains('is-open') ? 'true' : 'false');
      }, 0);
    }

    if (e.target.matches && e.target.matches('#DrawerBackdrop')) {
      var panel = document.querySelector('[data-filter-panel].is-open');
      if (panel) {
        panel.classList.remove('is-open');
        if (typeof backdrop === 'function') backdrop(false);
        var root = panel.closest('[data-facet-root]') || document;
        var trigger = root.querySelector('[data-filter-toggle]');
        if (trigger) {
          trigger.setAttribute('aria-expanded','false');
          trigger.focus();
        }
      }
    }

    var close = e.target.closest && e.target.closest('[data-filter-close]');
    if (close) {
      var root = close.closest('[data-facet-root]') || document;
      var trigger = root.querySelector('[data-filter-toggle]');
      if (trigger) trigger.setAttribute('aria-expanded','false');
    }
  }, true);
})();

/* v2.2.11 — truthful variant inventory + purchase-control synchronization. */
(function(){
  function variants(root){
    try { return JSON.parse(root.querySelector('[data-product-variants]')?.textContent || '[]'); }
    catch(e) { return []; }
  }
  function selectedVariant(root){
    var data=variants(root), groups=[].slice.call(root.querySelectorAll('[data-option-group]'));
    if(!groups.length) return data[0] || null;
    var chosen=groups.map(function(g){var b=g.querySelector('.is-selected');return b&&b.dataset.optionValue;});
    return data.find(function(v){return Array.isArray(v.options)&&v.options.every(function(o,i){return o===chosen[i];});}) || null;
  }
  function strictInventory(v){
    return !!(v && v.inventory_management && String(v.inventory_policy || 'deny').toLowerCase() !== 'continue');
  }
  function sizeLabel(root){
    var groups=[].slice.call(root.querySelectorAll('[data-option-group]'));
    var size=groups.find(function(g){return (g.querySelector('legend')?.textContent||'').trim().toLowerCase()==='size';});
    var selected=size && size.querySelector('.is-selected');
    return selected ? (selected.dataset.optionValue || selected.textContent || '').trim().toUpperCase() : '';
  }
  function inventoryMessage(root,v){
    if(!v) return 'UNAVAILABLE';
    if(!v.available) return 'SOLD OUT';
    if(!strictInventory(v)) return 'IN STOCK';
    var qty=Number(v.inventory_quantity);
    if(!Number.isFinite(qty)) return 'IN STOCK';
    if(qty<=0) return 'SOLD OUT';
    if(qty<=5){var size=sizeLabel(root);return '🔥 ONLY '+qty+' LEFT'+(size?' IN '+size:'')+' — GRAB IT BEFORE IT’S GONE';}
    if(qty<=10) return 'SELLING FAST';
    return 'IN STOCK';
  }
  function markOptions(root){
    var data=variants(root), groups=[].slice.call(root.querySelectorAll('[data-option-group]'));
    var chosen=groups.map(function(g){var b=g.querySelector('.is-selected');return b&&b.dataset.optionValue;});
    groups.forEach(function(group,index){
      group.querySelectorAll('[data-option-value]').forEach(function(btn){
        var candidate=chosen.slice(); candidate[index]=btn.dataset.optionValue;
        var matches=data.filter(function(v){return Array.isArray(v.options)&&v.options.every(function(o,i){return !candidate[i]||o===candidate[i];});});
        var sold=matches.length>0 && matches.every(function(v){return !v.available;});
        btn.classList.toggle('is-sold-out',sold);
        var label=(btn.dataset.fdBaseLabel || btn.textContent || btn.dataset.optionValue || '').trim();
        if(!btn.dataset.fdBaseLabel) btn.dataset.fdBaseLabel=label;
        if(sold){btn.setAttribute('title',label+' — Sold out');btn.setAttribute('aria-label',label+' — sold out');}
        else {btn.removeAttribute('title');btn.setAttribute('aria-label',label);}
      });
    });
  }
  function sync(root){
    if(!root) return;
    var v=selectedVariant(root), available=!!(v&&v.available), inv=root.querySelector('[data-inventory]');
    if(inv){
      inv.hidden=false;
      inv.textContent=inventoryMessage(root,v);
      inv.classList.toggle('is-low',available&&strictInventory(v)&&Number(v.inventory_quantity)>0&&Number(v.inventory_quantity)<=10);
      inv.classList.toggle('is-sold-out',!available);
    }
    var meter=root.querySelector('[data-stock-counter]'), bar=root.querySelector('[data-stock-bar]');
    if(meter){
      var measurable=!!(v&&strictInventory(v));
      meter.hidden=!measurable;
      meter.style.removeProperty('display');
      if(measurable){
        var qty=Math.max(0,Number(v.inventory_quantity)||0);
        if(bar) bar.style.width=Math.min(100,qty*10)+'%';
        meter.classList.toggle('is-sold-out',!available||qty<=0);
        meter.classList.toggle('is-low',available&&qty>0&&qty<=5);
        meter.classList.toggle('is-fast',available&&qty>5&&qty<=10);
      }
    }
    markOptions(root);
    var main=root.querySelector('[data-product-submit]');
    if(main){
      main.disabled=!available;
      main.setAttribute('aria-disabled',available?'false':'true');
      main.textContent=available?'▶ ADD TO CART':(v?'SOLD OUT':'UNAVAILABLE');
      if(!main.dataset.fdInventoryObserver){
        main.dataset.fdInventoryObserver='true';
        new MutationObserver(function(){
          var current=selectedVariant(root);
          if(!(current&&current.available) && !main.disabled) main.disabled=true;
        }).observe(main,{attributes:true,attributeFilter:['disabled']});
      }
    }
    var dynamic=root.querySelector('.dynamic-checkout-wrap');
    if(dynamic){dynamic.hidden=!available;dynamic.setAttribute('aria-hidden',available?'false':'true');}
    var sticky=document.querySelector('[data-sticky-atc]'), stickyBtn=sticky&&sticky.querySelector('[data-sticky-add]');
    if(stickyBtn){
      stickyBtn.disabled=!available;
      stickyBtn.setAttribute('aria-disabled',available?'false':'true');
      stickyBtn.textContent=available?(window.fdStickyAtcLabel||'ADD TO CART'):(v?'SOLD OUT':'UNAVAILABLE');
      sticky.classList.toggle('is-sold-out',!available);
    }
  }
  if(typeof updateVariant==='function'){
    var previous=updateVariant;
    updateVariant=function(root){var result=previous(root);sync(root);return result;};
  }
  function init(){document.querySelectorAll('[data-product-root]').forEach(sync);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll?.('[data-product-root]').forEach(sync);});
})();
